<template>
    <v-dialog v-model="show" max-width="768">
        <form v-on:submit.prevent="prevent"> 
        <v-card class="pa-6" :loading="loading">
            <v-card-title class="py-6 d-flex justify-space-between"><div class="text-h5 accent--text font-weight-bold">Forma de pagamento

                <v-btn small outlined class="mx-3">Histórico de alterações</v-btn>
            </div>
                <v-btn
                icon
                @click="show = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn></v-card-title>
            <v-card-text>
                <p><strong>Observações</strong></p>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Error quam repellendus culpa corrupti ratione veniam consectetur optio architecto sunt saepe ipsa quia sed corporis laborum tempore necessitatibus explicabo, sapiente veritatis!</p>
                <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedDateFormatted"
              label="Date (read only text field)"
              hint="MM/DD/YYYY format"
              persistent-hint
              prepend-inner-icon="mdi-calendar"
              readonly
              required
              :error-messages="dateFormattedErrors"
                @input="v$.dateFormatted.$touch()"
                @blur="v$.dateFormatted.$touch()"
                @keyup.enter="submit"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            no-title
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>

            </v-card-text>
            <v-card-actions class="v-card__actions d-flex justify-end pt-3 pb-3 px-6">
                <v-btn large elevation="0" type="button" @click="submit" :disabled="v$.$invalid && v$.dateFormatted.$dirty" :loading="processing" class="white--text">Recusar Grid</v-btn>
            </v-card-actions>
        </v-card>
        </form>
    </v-dialog>
</template>
<script>
    import useVuelidate from '@vuelidate/core'
    import { required } from '@vuelidate/validators'
    import moment from 'moment'
    export default {
        setup () {
            return { v$: useVuelidate() }
        },
        validations: {
            dateFormatted: { required },        
        },
        props: {
            open: Boolean
        },
        data: () => ({
            loading: false,
            processing: false,
            show: true,
            reason: "",
            date: moment().format('YYYY-MM-DD'),
            dateFormatted: moment().format('DD/MM/YYYY'),
            menu1: false,
            menu2: false,
        }),
        computed: {
            dateFormattedErrors () {
                const errors = []
                if (!this.v$.dateFormatted.$dirty) return errors

                this.v$.dateFormatted.required.$invalid && errors.push('Selecione uma data')
                return errors
            },
            computedDateFormatted () {
                return this.formatDate(this.date)
            },
        },
        watch: {
            date (val) {
                this.dateFormatted = this.formatDate(this.date)
            },
        },
        methods: {
            submit(){
                this.v$.$touch()
                if(!this.v$.$invalid){
                    alert('enviar')
                }
            },
            prevent(event){
              event.stopPropagation()
            },
            formatDate (date) {
                if (!date) return null
                return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY')
                },
            parseDate (date) {
                if (!date) return null

                return moment(date,'DD/MM/YYYY').format('YYYY-MM-DD')
            },
        
        }
    }
</script>